export enum TABLE_ACTIONS {
    Creating = "creating",
    Deleting = "deleting",
    Updating = "updating"
}

export enum CUSTOM_GROUP_NAMES {
    BackgroundActions = "backgroundActions",
    Licenses = "licenses",
    User = "user"
}

export enum EVENT_NAMES {
    BackgroundAction = "backgroundAction",
    Company = "company",
    Device = "device",
    DeviceGroup = "group",
    DeviceModel = "deviceModel",
    DeviceModelTaskCompatibility = "deviceModelTaskCompatibility",
    File = "file",
    License = "license",
    ProductCode = "productCode",
    Role = "role",
    Task = "task",
    TaskGroup = "batch",
    User = "user"
}
